import { motion } from "framer-motion";

export function BulkProgressBar({ currentIdx, totalOutputs, progress }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-xs">
        <span className="text-[var(--text-secondary)]">
          Generating {currentIdx + 1} of {totalOutputs}...
        </span>
        <span className="font-['JetBrains_Mono'] text-[#FF4400]">{Math.round(progress)}%</span>
      </div>
      <div className="h-2 bg-[var(--bg-raised)] rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-[#FF4400] rounded-full"
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </div>
  );
}
